import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DetalhesSuperSocialModalComponent } from './detalhes-super-social-modal.component';
import { DetalhesSuperSocialComponent } from './detalhes-super-social.component';

@NgModule({
  declarations: [
    DetalhesSuperSocialModalComponent,
    DetalhesSuperSocialComponent,
  ],
  imports: [
    // root
    CommonModule,
    IonicModule
  ],
  exports: [
    DetalhesSuperSocialComponent,
    DetalhesSuperSocialModalComponent,
  ]
})
export class DetalhesSuperSocialModule { }
